<template>
  <div class="p-0 clickable notification__item" :class="notificationDynamicClass" v-if="notification" @click="doAction">
    <div class="border-radius justify-content-center align-items-center notification__pin" :class="pinDynamicClass" @click="clickPin">
      <svg v-if="isPinned" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M10.2572 15.0146C9.82465 15.0146 9.39205 14.8696 8.95946 14.5798L6.72434 12.3334L1.89365 17.1885C1.74946 17.3334 1.60526 17.3334 1.46106 17.3334C1.31686 17.3334 1.02846 17.3334 0.884266 17.1885C0.59587 16.8986 0.59587 16.4638 0.884266 16.174L5.71496 11.3189L3.47993 9.07254C3.40783 9.00008 3.37178 8.92761 3.33573 8.85515C3.29968 8.78269 3.26363 8.71022 3.19153 8.63776C3.04733 8.20297 2.90313 7.76819 3.04733 7.33341C3.19153 6.89863 3.47993 6.46385 3.91252 6.31892C5.06611 5.59428 6.36389 5.44935 7.66167 5.59428L10.2572 1.53631C10.2572 1.44674 10.3123 1.41253 10.3884 1.36525C10.4355 1.33603 10.4906 1.30182 10.5456 1.24646C10.834 0.956603 11.2666 0.666748 11.6992 0.666748C12.1318 0.666748 12.5644 0.811676 12.8528 1.24646L17.0346 5.44935C17.6113 6.31892 17.323 7.33341 16.4578 7.91312L12.4202 10.3769C12.5644 11.6812 12.4202 12.9856 11.6992 14.145C11.6992 14.2899 11.555 14.4348 11.4108 14.5798C11.1224 14.8696 10.6898 15.0146 10.2572 15.0146Z" fill="#1E232F" />
      </svg>
      <svg v-else class="icon-hover" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.001 16.3334C10.501 16.6667 11.001 16.8334 11.501 16.8334C12.001 16.8334 12.501 16.6667 12.8343 16.3334C13.001 16.1667 13.1677 16 13.1677 15.8334C14.001 14.5 14.1677 13 14.001 11.5L18.6677 8.66671C19.6677 8.00004 20.001 6.83337 19.3343 5.83337L14.501 1.00004C14.1677 0.500041 13.6677 0.333374 13.1677 0.333374C12.6677 0.333374 12.1677 0.666707 11.8343 1.00004C11.7707 1.0637 11.707 1.10305 11.6526 1.13665C11.5647 1.19102 11.501 1.23037 11.501 1.33337L8.501 6.00004C7.001 5.83337 5.501 6.00004 4.16767 6.83337C3.66767 7.00004 3.33433 7.50004 3.16767 8.00004C3.001 8.50004 3.16767 9.00004 3.33434 9.50004C3.41767 9.58337 3.45934 9.66671 3.501 9.75004C3.54267 9.83337 3.58434 9.91671 3.66767 10L6.25116 12.5835L0.667969 18.1667C0.334635 18.5 0.334635 19.0001 0.667969 19.3334C0.834635 19.5001 1.16797 19.5 1.33464 19.5C1.5013 19.5 1.66797 19.5001 1.83464 19.3334L7.41782 13.7502L10.001 16.3334ZM4.83434 8.66671C4.66767 8.50004 4.83433 8.33337 5.001 8.16671C6.001 7.50004 7.33433 7.33337 8.66767 7.66671C9.001 7.83337 9.33434 7.66671 9.501 7.33337L12.8343 2.16671C12.8343 2.00004 13.001 2.00004 13.001 2.00004C13.0843 2.00004 13.126 2.04171 13.1677 2.08337C13.2093 2.12504 13.251 2.16671 13.3343 2.16671L17.8343 6.83337C17.8343 7.00004 17.8343 7.16671 17.6677 7.33337L12.6677 10.5C12.3343 10.6667 12.3343 11 12.3343 11.3334C12.501 12.6667 12.3343 14 11.6677 15.1667H11.3343L4.83434 8.66671Z" fill="#1E232F" />
      </svg>
    </div>
    <div v-if="notification.img_url && notification.img_url != ''" class="notification__img">
      <img :src="notification.img_url" />
    </div>
    <div class="p-2">
      <h6 class="heading-h6-14-semi txt-dark-high-contrast notification__title" v-html="title">
      </h6>
      <div class="d-flex mt-1" v-if="hasTags">
        <div class="border-radius body-10-medium  notification__tag important" v-if="notification.is_important">
          {{ importantTagText }}
        </div>
      </div>
      <p class="body-14-regular text-dark-subtext2" :class="timeDynamicClass">
        {{ timeago }}
      </p>
      <div class="body-14-regular text-dark-subtext2 mt-2" v-html="desc"></div>
    </div>
  </div>
</template>

<script>
import getLocale from "@/mixins/getLocale.js";
import { mapActions, mapGetters } from "vuex";
import { TimeMaker } from "@/plugins";

export default {
  name: "NotificationItem",
  filters: {
    /**
     * if noti day is today, show hour and minute only,otherwise show day, mmonth,year
     */
    formatAMPM(value) {
      let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let date = new Date(value);
      let d = new Date();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      let strTime = "";
      if (d.getMonth() == date.getMonth() && d.getDate() == date.getDate() && d.getFullYear() == date.getFullYear()) {
        strTime = hours + ":" + minutes + " " + ampm;
      } else {
        strTime = months[date.getMonth()] + " " + date.getDate() + " " + date.getFullYear() + " " + hours + ":" + minutes + " " + ampm;
      }
      return strTime;
    }
  },
  mixins: [getLocale],
  props: {
    notification: {
      type: Object,
      default: null
    },
    pinned: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("account", {
      language: "displayLanguage"
    }),
    timeago() {
      return new TimeMaker(this.notification.base_created).ago(this.language);
    },
    title() {
      return this.getLocaleText(this.notification.title);
    },
    desc() {
      return this.getLocaleText(this.notification.desc);
    },
    importantTagText() {
      return "IMPORTANT";
    },
    hasTags() {
      return this.notification.is_important;
    },
    timeDynamicClass() {
      return {
        "mt-2": this.hasTags,
        "mt-4px": !this.hasTags
      };
    },
    isPinned() {
      return this.notification.state == 2;
    },
    notificationDynamicClass() {
      return {
        readed: this.notification.state >= 1,
        pinned: this.isPinned
      };
    },
    pinDynamicClass() {
      return {
        pinned: this.isPinned
      };
    },
  },
  methods: {
    ...mapActions("notibar", {
      pinNoti: "pinNoti2",
      unpinNoti: "unpinNoti",
      showModalNoti: "showModalNoti",
      trackAction: "trackAction",
      openNotiContent: "openNotiContent"
    }),
    pinNotification() {
      const noti = this.notification
      this.pinNoti({
        noti,
        onLoading: () => {
          this.gSnackbarCommit({
            message: this.$t("status.processing"),
            type: "loading"
          });
        },
        onSuccess: () => {
          this.gSnackbarCommit({
            message: this.$t("generals.notiCenter.status.pinSuccess"),
            type: "success"
          });
        },
        onError: () => {
          this.gSnackbarCommit({
            message: "Something went wrong",
            type: "error"
          });
        }
      });
    },
    unpinNotification() {
      const noti = this.notification
      this.unpinNoti({
        noti,
        onLoading: () => {
          this.gSnackbarCommit({
            message: this.$t("status.processing"),
            type: "loading"
          });
        },
        onSuccess: () => {
          this.gSnackbarCommit({
            message: this.$t("generals.notiCenter.status.unpinSuccess"),
            type: "success"
          });
        },
        onError: err => {
          this.gSnackbarCommit({
            message: err,
            type: "error"
          });
        }
      });
    },
    clickPin(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.isPinned) {
        this.unpinNotification();
      } else {
        this.pinNotification();
      }
    },
    doAction() {
      if (["open_modal", "welcome_back"].includes(this.notification.action)) {
        this.showModalNoti(this.notification);
        this.trackAction(this.notification);
      } else if (this.notification.action == "open_url") {
        this.openNotiContent(this.notification);        
        this.trackAction(this.notification);
      }
    },
  }
};
</script>

<style lang="scss">
.notification {
  &__item {
    width: 100%;
    margin-top: 16px;
    border-radius: $radius;
    position: relative;

    background-color: map-get($light-grey, "600");

    &:hover {
      background-color: map-get($light-grey, "500");
      box-shadow: 0px 2px 8px rgba(84, 90, 116, 0.12), 0px 2px 4px rgba(84, 90, 116, 0.1);

      .notification__pin {
        display: flex;
      }
    }

    &.readed {
      background-color: map-get($light-grey, "500");
    }

    &.pinned {
      border: 1px solid $mono3;
    }

    &:first-child {
      margin-top: 0;
    }
  }

  &__tag {
    padding: 3px 6px;
    &.important {
      color: map-get($accent-red-new, "300");
      background-color: map-get($accent-red-new, "500");
    }
  }

  &__img {
    width: 100%;
    height: auto;
    border-radius: $radius;
    overflow: hidden;
    position: relative;

    img {
      width: 100%;
      height: auto;
    }
  }

  &__title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    max-height: 1.5em;
    width: 100%;
    -webkit-line-clamp: 1;
  }

  &__pin {
    position: absolute;
    top: 8px;
    right: 8px;
    height: 32px;
    width: 32px;
    display: none;
    background-color: rgba(map-get($light-grey, "200"), 0.5);

    .icon-hover {
      &:hover {
        path {
          fill: map-get($primary, "300");
        }
      }
    }

    &.pinned {
      display: flex;
    }
  }
}
</style>
